import { DropdownMenu, GhostIconButton, MenuItem } from "@certn/cascadia-react";
import { t } from "i18next";
import { useFlags } from "launchdarkly-react-client-sdk";
import React from "react";
import { useNavigate } from "react-router-dom";

import { toggleFavourite } from "../helpers";

interface Props {
  groupId: string;
  isFavourite: boolean;
  mutate: () => void;
}

export function GroupOverviewDropdownMenu(props: Props) {
  const { groupId, isFavourite, mutate } = props;
  const navigate = useNavigate();
  const { clientPortalEnableGroupFavourites } = useFlags();

  return (
    <>
      <DropdownMenu
        triggerButton={
          <GhostIconButton
            size="small"
            icon="expand_more"
            testID="group-title-dropdown-trigger"
          />
        }
        placement="bottom right"
        onItemAction={(key) => {
          switch (key) {
            case "remove_from_favourites_button":
            case "add_to_favourites_button":
              toggleFavourite(groupId, isFavourite, t, mutate);
              break;
            case "group_members_button":
              navigate(`/groups/${groupId}/members`);
              break;
            case "group_details_button":
              navigate(`/groups/${groupId}`);
              break;
            default:
              break;
          }
        }}
      >
        {clientPortalEnableGroupFavourites &&
          (isFavourite ? (
            <MenuItem
              id="remove_from_favourites_button"
              minWidth="196px"
              textColor="text-base"
              textStyle="input/text-field"
              icon="star"
            >
              {t("Remove from favourites")}
            </MenuItem>
          ) : (
            <MenuItem
              id="add_to_favourites_button"
              minWidth="196px"
              textColor="text-base"
              textStyle="input/text-field"
              icon="star"
            >
              {t("Add to favourites")}
            </MenuItem>
          ))}
        <MenuItem
          id="group_members_button"
          minWidth="196px"
          textColor="text-base"
          textStyle="input/text-field"
          icon="person"
        >
          {t("Members")}
        </MenuItem>

        <MenuItem
          id="group_details_button"
          minWidth="196px"
          textColor="text-base"
          textStyle="input/text-field"
          icon="settings"
        >
          {t("Group details")}
        </MenuItem>
      </DropdownMenu>
    </>
  );
}
